import { useState, useCallback } from 'react'
import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import TopBar from '../shared/components/navigation/TopBar'
import Sidebar from '../shared/components/navigation/Sidebar'

function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const handleMenuToggle = useCallback(() => setMobileOpen((prev) => !prev), [])
  const handleDrawerClose = useCallback(() => setMobileOpen(false), [])

  return (
    <Box sx={{ display: 'flex', bgcolor: 'navigation.main', height: '100vh', overflow: 'hidden' }}>
      <TopBar onMenuToggle={handleMenuToggle} />
      <Sidebar open={mobileOpen} onClose={handleDrawerClose} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          p: { xs: 0, md: 1 },
          pt: 0,
          minHeight: 0,
        }}
      >
        <Toolbar />
        <Box
          data-scroll-container
          sx={{
            flexGrow: 1,
            bgcolor: 'background.default',
            borderRadius: { xs: 0, md: 3 },
            overflow: 'auto',
            minHeight: 0,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}

export default AppLayout
